import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { EmptyQueue } from './empty-queue';
import { DisplayQueue } from './display-queue';
import { LoadingPanel } from './loading-panel';
import { NotificationQueueContext, severityTypes } from './util/constants';

export const NotificationQueue = props => (
  <NotificationQueueContext.Provider
    value={{
      logger: props.logger,
      logContent: props.logContent,
      i18n: props.i18n,
      isUINext: props.isUINext,
    }}
  >
    <div
      role="dialog"
      aria-modal="true"
      aria-label={props.header.title}
      aria-live="polite"
      className="notification-queue"
    >
      {props.showLoading && (
        <LoadingPanel {..._.omit(props, 'notifications', 'emptyText', 'footer')} />
      )}
      {!props.showLoading && (
        _.isEmpty(props.notifications) ? (
          <EmptyQueue {..._.omit(props, 'notifications', 'footer')} />
        ) : (
          <DisplayQueue {..._.omit(props, 'emptyText')} />
        )
      )}
      <button
        tabIndex="0"
        className={classNames('notification-queue-dismiss', 'close', 'dismiss', 'closeimage', 'disableEsc', 'clickable', 'btn')}
        onClick={props.closeQueue}
        aria-label={props.i18n.getString(_TL_('Close the panel'))}
      />
    </div>
  </NotificationQueueContext.Provider>
);

NotificationQueue.propTypes = {
  header: PropTypes.shape({
    title: PropTypes.string,
    text: PropTypes.string,
    href: PropTypes.string,
    action: PropTypes.func,
    isJumpOut: PropTypes.bool,
  }).isRequired,
  footer: PropTypes.shape({
    text: PropTypes.string,
    href: PropTypes.string,
    action: PropTypes.func,
  }).isRequired,
  emptyText: PropTypes.string.isRequired,
  showLoading: PropTypes.bool.isRequired,
  notifications: PropTypes.arrayOf(PropTypes.shape({
    severity: PropTypes.oneOf(severityTypes),
    id: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    title: PropTypes.string,
    message: PropTypes.string,
    actionList: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string,
      href: PropTypes.string,
      action: PropTypes.func,
      extraClassNames: PropTypes.arrayOf(PropTypes.string),
      extraAttrs: PropTypes.objectOf(PropTypes.string),
      callbackType: PropTypes.string,
      isJumpOut: PropTypes.bool,
    })),
    dismissAction: PropTypes.func,
  })),
  actionCallback: PropTypes.func,
  closeQueue: PropTypes.func,
  logger: PropTypes.shape({
    trace: PropTypes.func,
  }),
  logContent: PropTypes.func,
  isUINext: PropTypes.bool.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
};

NotificationQueue.defaultProps = {
  notifications: [],
  actionCallback: _.noop,
  closeQueue: _.noop,
  logger: {
    trace: _.noop,
  },
  logContent: _.noop,
};
